let guid;
let mask = require("../modules/mask/index");

function request() {}
//发送请求
request.send = function (obj, cb) {
  if (!guid) {
    try {
      guid = qbsdk.getGuid();//window.external.getGuid().split("-").join("")
    } catch (e) {}
  }
  if (qbsdk.isQB()/*api.isQB*/) {
    zUtil.ensureLogin(function () {
      obj.guid = guid;
      zHttp.send(obj, function (res) {
        if (res.ret == 10002) {
          qq.login.open();
        } else if (res.ret == 10004) {
          //todo
        } else {
          cb && cb(res);
        }
      })
    })
  }
  // else {
  //   mask("QBrowser")
  // }
}



module.exports = request



// WEBPACK FOOTER //
// ./common/request.js